import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiData } from '@wix/da-bi/pkg/events';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink/PlainButtonOrLink';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { ModalType } from '../../../Modals/redux/types';
import { usePushModal } from '../../../utils/hooks/usePushModal';
import s from './AISuppressionSettingItem.scss';
/** AI (Topic) Suppression level as menu item for user menu */ export const AISuppressionSettingItem = (_param)=>{
    var { isLoggedIn } = _param, props = _object_without_properties(_param, [
        "isLoggedIn"
    ]);
    return isLoggedIn ? /*#__PURE__*/ React.createElement(LoggedInSetting, props) : /*#__PURE__*/ React.createElement(LoggedOutSetting, props);
};
export default AISuppressionSettingItem;
/** opens setting modal when clicked (no current watch level shown) */ const LoggedInSetting = ({ className })=>{
    const { t } = useTranslation();
    const pushAISuppressionModal = usePushModal(ModalType.AI_SUPPRESSION_SETTINGS);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: classnames(s['root'], className),
        onClick: ()=>pushAISuppressionModal({}),
        biData: BiData({
            evid: 702,
            menu_name: 'profile',
            menu_item: 'ai-content'
        })
    }, t('siteHeader.userMenu.aiContent'));
};
/** Presents a fake toggle that sends user to the join page when clicked */ export const LoggedOutSetting = ({ className })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const [toggled, setToggled] = useState(false);
    const { sendUserToJoinPage } = useRestrictToLoggedIn();
    return /*#__PURE__*/ React.createElement("label", {
        id: "user-menu-ai-label",
        className: classnames(s['root'], className)
    }, t('siteHeader.userMenu.aiContent.anon'), /*#__PURE__*/ React.createElement(MainToggle, {
        "aria-labelledby": "user-menu-ai-label",
        size: isMobile ? 'medium' : 'small',
        value: toggled,
        onChange: ()=>{
            setToggled(true);
            // note: fires bi event 240
            sendUserToJoinPage(ReferralType.TOPIC_WATCH_CHANGE);
        }
    }));
};
